import React from 'react';
import { Link } from 'react-router-dom';
import { useFirebaseAuth } from '../context/FirebaseAuthContext';
import './Navigation.css';

function Navigation() {
  const { user, login, logout } = useFirebaseAuth();

  return (
    <nav className="navigation">
      <div className="nav-brand">
        <Link to="/">Chalkolate</Link>
      </div>
      <div className="nav-links">
        {user ? (
          <>
            <Link to="/" className="nav-link">Dashboard</Link>
            <div className="user-menu">
              <img
                src={user.photoURL}
                alt={user.displayName || user.email}
                className="user-avatar"
                style={{ width: '40px', height: '40px' }}
              />
              <div className="user-dropdown">
                <button onClick={logout} className="logout-button">
                  Logout
                </button>
              </div>
            </div>
          </>
        ) : (
          <button onClick={login} className="login-button">
            Login
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navigation; 